import React from 'react';

const Fullscreen = ({ height = 32, width = 32, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <title>fullscreen 76</title>
    <g fill={color}>
      <polygon fill={color} points="13.414,12 7.207,5.793 12,1 1,1 1,12 5.793,7.207 12,13.414 "/>
      <polygon points="20,13.414 26.207,7.207 31,12 31,1 20,1 24.793,5.793 18.586,12 "/>
      <polygon fill={color} points="18.586,20 24.793,26.207 20,31 31,31 31,20 26.207,24.793 20,18.586 "/>
      <polygon points="12,18.586 5.793,24.793 1,20 1,31 12,31 7.207,26.207 13.414,20 "/>
    </g>
  </svg>
);

export default Fullscreen;
